<template>
  <div class="member-selector">
    <button v-if="modelValue === 0" class="button secondary expanded select-button" @click="$emit('update:modelValue', 1)">Select</button>
    <div v-else class="qty-controls label">
      <button
        class="minus-button"
        :aria-label="modelValue === 1 ? 'Remove item' : 'Decrease quantity'"
        @click="$emit('update:modelValue', modelValue - 1)"
      >
        <Icon v-if="modelValue === 1" :icon="csgDelete" theme="dark" size="m" :aria-hidden="true" class="icon-delete" />
        <Icon v-else :icon="csgAccordionMinus" theme="dark" size="m" :aria-hidden="true" class="icon-minus" />
      </button>

      <span class="qty-text">Qty {{ modelValue }}</span>

      <button class="plus-button" aria-label="Increase quantity" :disabled="modelValue >= max" @click="$emit('update:modelValue', modelValue + 1)">
        <Icon :icon="csgAccordionPlus" theme="dark" size="m" :aria-hidden="true" class="icon-plus" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '@atomic-ui/icon/Icon.vue';
import { csgDelete, csgAccordionMinus, csgAccordionPlus } from '@csgSvgIcons/icons';

withDefaults(
  defineProps<{
    modelValue: number;
    max?: number;
  }>(),
  {
    max: 10,
  },
);

defineEmits<(e: 'update:modelValue', value: number) => void>();
</script>






<style lang="scss" scoped>
@import '~settingSCSS';

.member-selector {
  width: 100%;
  max-width: 342px;
}

.select-button {
  height: 50px;
  margin: 0;
}

.qty-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: 50px;
  background: $white;
}

.minus-button,
.plus-button {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  background: transparent;
  color: $black;
  border: none;
  cursor: pointer;
  padding: 0;

  &:hover:not(:disabled) {
    background-color: $background-color;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.qty-text {
  flex-grow: 1;
  text-align: center;
  white-space: nowrap;
}


@import '~settingSCSS';

.member-selector {
  .qty-controls {
    border: 2px solid $black;
    border-radius: 5px;
  }
}
</style>